import { Grid, Typography } from '@mui/material'
import React from 'react'

const DraftMessage = () => {
    return (
        <Grid display={'flex'} flexDirection={'column'} alignItems={'center'} justifyContent={'center'} mt={'150px'} width={'100%'} mx={'auto'}>
            <Grid mb={'24px'} width={'100px'} height={'100px'} bgcolor={'#1E3E62'} borderRadius={'50%'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
                <img src='/assets/images/memo.svg' alt='' style={{ width: '60px', height: '60px' }} />
            </Grid>
            <Grid mb={'28px'} display={'flex'} flexDirection={'column'} alignItems={'center'} justifyContent={'center'}>
                <Typography variant='h5' color={'#000'} fontWeight={700} mb={'8px'}>{'پیش نویس های شما خالی است!'}</Typography>
            </Grid>
        </Grid>
    )
}

export default DraftMessage